module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_ES.63746673.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust_PDF/GDocsCookieNotice_ES.pdf
// module id = 691
// module chunks = 4